<iframe 
    [src]="url"
width='100%' height='98%' frameborder='0' (load)="isIframeLoaded()" id="iframe_{{id}}">
    This is an embedded 
    <a target='_blank' href='http://office.com'>Microsoft Office</a> document, powered by <a target='_blank' href='http://office.com/webapps'>Office Online</a>.
</iframe>

